import { POST_JSON, GET, FILE, PUT_JSON, PATCH_JSON, DELETE } from '../utils/axios'
import axiosInstance from '../utils/axios'
import { API_PREFIXES } from './config'

export const getLogin = (data = {}) => {
    return POST_JSON(`${API_PREFIXES.AUTH}/login`, data)
}
export const refreshLogin = (data = {}) => {
    return POST_JSON(`${API_PREFIXES.AUTH}/refresh`, data)
}

// Admin API keys (工厂密钥) 相关接口
export const getAdminApiKeys = (data: { page?: number; page_size?: number } = {}) => {
    return GET(`${API_PREFIXES.ADMIN}/api-keys`, data);
};

export const createAdminApiKey = (data: { name: string; scopes: string[] }) => {
    return POST_JSON(`${API_PREFIXES.ADMIN}/api-keys`, data);
};

export const deleteAdminApiKey = (id: string) => {
    return DELETE(`${API_PREFIXES.ADMIN}/api-keys/${id}`, {});
};

export const revokeAdminApiKey = (id: string) => {
    return PUT_JSON(`${API_PREFIXES.ADMIN}/api-keys/${id}/revoke`, {});
};

// Admin device passwords 相关接口
export const getDevicePasswords = (data: {
    batch_number?: string;
    status?: string;
    mac_address?: string;
    page?: number;
    page_size?: number;
} = {}) => {
    return GET(`${API_PREFIXES.ADMIN}/device-passwords`, data);
};

export const getDevicePasswordDetail = (id: string) => {
    return GET(`${API_PREFIXES.ADMIN}/device-passwords/${id}`, {});
};

export const deleteDevicePassword = (id: string) => {
    return DELETE(`${API_PREFIXES.ADMIN}/device-passwords/${id}`, {});
};

export const setDevicePasswordExpiration = (id: string, data: { expires_at: string }) => {
    return PUT_JSON(`${API_PREFIXES.ADMIN}/device-passwords/${id}/expire`, data);
};

export const getDevicePasswordAuditLog = (data: {
    password_id?: string;
    page?: number;
    page_size?: number;
} = {}) => {
    return GET(`${API_PREFIXES.ADMIN}/device-passwords/audit-log`, data);
};

/** 导出设备密码 CSV（带认证，返回 blob） */
export const exportDevicePasswordsCsv = () => {
    const token = typeof localStorage !== 'undefined' ? localStorage.getItem('accessToken') : null;
    return axiosInstance.get(`${API_PREFIXES.ADMIN}/device-passwords/export`, {
        responseType: 'blob',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
};
export const updatePassword = (data: { old_password: string; new_password: string }) => {
    return PUT_JSON(`${API_PREFIXES.AUTH}/password`, data);
};
export const getAppUsers = (data: {
    page?: number;
    page_size?: number;
    email?: string;
    phone?: string;
    role?: string;
    sort_by?: string;
    sort_order?: string;
} = {}) => {
    return GET(`${API_PREFIXES.ADMIN}/users`, data);
};
export const accountList = (data = {}) => {
    return GET(`${API_PREFIXES.BACKYARD}/admin/users`, data)
}
export const accountDetail = (data: any = {}) => {
    return GET(`${API_PREFIXES.BACKYARD}/admin/users/${data.account_id}`, {})
}
export const saveAccount = (data = {}) => {
    return POST_JSON(`${API_PREFIXES.BACKYARD}/admin/users`, data)
}
export const putAccount = (data: any = {}) => {
    return PUT_JSON(`${API_PREFIXES.BACKYARD}/admin/users/${data.id}`, data)
}

export const getDeviceInfos = (data = {}) => {
    return GET(`${API_PREFIXES.ADMIN}/devices`, data)
}
export const DelDeviceInfo = (data: any = {}) => {
    return DELETE(`${API_PREFIXES.BACKYARD}/device/${data.device_id}`, {})
}
export const getDeviceProfile = (data = {}) => {
    return GET(`${API_PREFIXES.BACKYARD}/deviceProfileInfos`, data)
}

// 设备清单管理相关接口
export const getDeviceManifests = (data = {}) => {
    return GET(`${API_PREFIXES.ADMIN}/catalog/manifests`, data)
}

export const addDeviceManifest = (data: { sn_type: string; icon: string; label: string; description?: string }) => {
    return POST_JSON(`${API_PREFIXES.ADMIN}/catalog/manifests`, data)
}

export const updateDeviceManifest = (id: string, data: { sn_type?: string; icon?: string; label?: string; description?: string }) => {
    return PUT_JSON(`${API_PREFIXES.ADMIN}/catalog/manifests/${id}`, data)
}

export const deleteDeviceManifest = (id: string) => {
    return DELETE(`${API_PREFIXES.ADMIN}/catalog/manifests/${id}`, {})
}

export const batchDeleteDeviceManifests = (ids: string[]) => {
    return DELETE(`${API_PREFIXES.ADMIN}/catalog/manifests/batch`, { ids })
}

// 上传文件
export const uploadFile = (file: File) => {
    return FILE(`${API_PREFIXES.ADMIN}/upload`, { file })
}
export const DelUsersInfo = (data: any = {}) => {
    return DELETE(`${API_PREFIXES.BACKYARD}/admin/users/${data.id}`, {})
}

// 鱼缸分类相关接口
export const getTankCategories = (data = {}) => {
    return GET(`${API_PREFIXES.BACKYARD}/tank_category`, data)
}

export const addTankCategory = (data: { name: string }) => {
    return POST_JSON(`${API_PREFIXES.BACKYARD}/tank_category`, data)
}

export const deleteTankCategory = (id: string) => {
    return DELETE(`${API_PREFIXES.BACKYARD}/tank_category/${id}`, {})
}

export const updateTankCategory = (id: string, data: { name: string }) => {
    return PUT_JSON(`${API_PREFIXES.BACKYARD}/tank_category/${id}`, data)
}

// 鱼缸二级分类（tank_resources）相关接口
export const getTankResources = (data = {}) => {
    return GET(`${API_PREFIXES.BACKYARD}/tank_resources`, data)
}

export const addTankResource = (data: any) => {
    return POST_JSON(`${API_PREFIXES.BACKYARD}/tank_resource`, data)
}

export const deleteTankResource = (id: string) => {
    return DELETE(`${API_PREFIXES.BACKYARD}/tank_resource/${id}`, {})
}

export const updateTankResource = (id: string, data: any) => {
    return POST_JSON(`${API_PREFIXES.BACKYARD}/tank_resource`, data)
}

export const getTankResourceDetail = (id: string) => {
    return GET(`${API_PREFIXES.BACKYARD}/tank_resource/${id}`, {})
}

export const publishTankResource = (id: string, data: { version: string }) => {
    return POST_JSON(`${API_PREFIXES.BACKYARD}/tank_resources/${id}/publish`, data)
}

// 设备型号相关接口
export const getDeviceModels = (data = {}) => {
    return GET(`${API_PREFIXES.ADMIN}/catalog/staging/device-models`, data)
}

export const promoteCatalog = (data: { prune?: boolean, device_model_id: number }) => {
    return POST_JSON(`${API_PREFIXES.ADMIN}/catalog/promote`, data)
}

// OTA 固件管理相关接口
export const getFirmwareList = (data = {}) => {
    return GET(`${API_PREFIXES.ADMIN}/ota/firmware`, data)
}

export const getFirmwareDetail = (id: string) => {
    return GET(`${API_PREFIXES.ADMIN}/ota/firmware/${id}`, {})
}

export const deleteFirmware = (id: string) => {
    return DELETE(`${API_PREFIXES.ADMIN}/ota/firmware/${id}`, {})
}

export const triggerOTA = (id: string, data: { sn: string }) => {
    return POST_JSON(`${API_PREFIXES.ADMIN}/ota/firmware/${id}/trigger`, data)
}

export const uploadFirmware = (formData: FormData) => {
    return FILE(`${API_PREFIXES.ADMIN}/upload/ota`, formData)
}

export const getFeedbackList = (data = {}) => {
    return GET(`${API_PREFIXES.ADMIN}/feedback`, data)
}

// 反馈详情（含评论时间线）
export const getFeedbackDetail = (id: string) => {
    return GET(`${API_PREFIXES.ADMIN}/feedback/${id}`, {})
}

// 更新反馈状态（submitted / in_progress / resolved / closed）
export const updateFeedbackStatus = (id: string, data: { status: string }) => {
    return PATCH_JSON(`${API_PREFIXES.ADMIN}/feedback/${id}/status`, data)
}

// 管理员回复（字段名为 body，对齐后端 CreateFeedbackCommentRequest）
export const addFeedbackComment = (id: string, data: { body: string }) => {
    return POST_JSON(`${API_PREFIXES.ADMIN}/feedback/${id}/comments`, data)
}

// 鱼缸管理相关接口
export const getTanks = (data: {
    user_id?: string;
    type?: string;
    created_after?: string;
    page?: number;
    page_size?: number;
    sort_by?: string;
    sort_order?: 'asc' | 'desc';
} = {}) => {
    return GET(`${API_PREFIXES.ADMIN}/tanks`, data);
};

// 自动化模板批量升级 (admin) 相关接口
export interface AdminMigrateRequest {
    family_key: string;
    from_version: number;
    dry_run?: boolean;
    force_defaults?: boolean;
    limit?: number; // 0 = unlimited
}

export const previewAutomationMigration = (data: AdminMigrateRequest) => {
    return POST_JSON(`${API_PREFIXES.ADMIN}/automations/migration/preview`, data);
};

export const applyAutomationMigration = (data: AdminMigrateRequest) => {
    return POST_JSON(`${API_PREFIXES.ADMIN}/automations/migration/apply`, data);
};